<div class="clickable-body" [cdkMenuTriggerFor]="disabled ? null : dropdown">
  <ng-content></ng-content>
</div>
<ng-template #dropdown>
  <app-x-menu
    [items]="options"
    [active]="ngModel"
    (activeChange)="onItemSelected($event)"
    [withSelectedIcons]="withSelectIcons"
    cdkMenu
  ></app-x-menu>
</ng-template>
